/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountSortCriteria {
    getFixupPrototypeFunction() { return ServiceAccountSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountSortCriteria>): ServiceAccountSortCriteria {
        let obj = Object.assign(new ServiceAccountSortCriteria(), model);
        ServiceAccountSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountSortCriteria>): ServiceAccountSortCriteria {
        if (!model) return null;
        return ServiceAccountSortCriteria.newInstance(<ServiceAccountSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountSortCriteria) {
        if (!obj) return;

        models.ServiceAccountSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountSortCriteria): boolean {
        Object.setPrototypeOf(obj, ServiceAccountSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.ServiceAccountSortColumn;

    ascending: boolean;

}
